import { render, staticRenderFns } from "./ExchangeVipPop.vue?vue&type=template&id=5b7a537d&scoped=true&"
import script from "./ExchangeVipPop.vue?vue&type=script&lang=js&"
export * from "./ExchangeVipPop.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeVipPop.vue?vue&type=style&index=0&id=5b7a537d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a537d",
  null
  
)

export default component.exports